import {DAILY_STREAK_A_B_TEST_TOGGLE} from '@/constants';

export enum LocationType {
  Location1 = 'location_0',
  Location2 = 'location_1',
  Location3 = 'location_2',
  Location4 = 'location_3',
}

export type ProjectUserInfoData = {
  user: {
    id: string;
    ssoId: string;
  };
  settings: {
    remindersEnabled: boolean;
    musicEnabled: boolean;
    soundsEnabled: boolean;
  };
  game: {
    location: {
      type: LocationType;
    };
    isDailyCompleted: boolean;
  };
  aBTestInfo: {
    [DAILY_STREAK_A_B_TEST_TOGGLE]: {
      flagMetadata?: Record<string, string | number | boolean>;
    } | null;
  } | null;
  dailyRewards: {
    availableToday: boolean;
  };
  onboarding: {
    projectOnboardingStatus: string;
    onboardingGiftIsAvailable: boolean;
  };
};
export type ProjectUserLoginData = {authToken: string};
